<ng-container *ngIf="vm$ | async as vm">
  <div class="file-viewer-overlay">
    <div class="file-viewer-topbar">
      <div class="file-viewer-name">
        {{ vm.fileName || 'קובץ' }}
      </div>
    </div>

    <div class="file-viewer-content">
      <div *ngIf="vm.loading" class="file-viewer-state">
        טוען קובץ...
      </div>

      <div *ngIf="!vm.loading && vm.error" class="file-viewer-state error">
        {{ vm.error }}
      </div>

      <img
        *ngIf="!vm.loading && vm.fileUrl && vm.isImage"
        class="file-viewer-image"
        [src]="vm.fileUrl"
        alt="file preview" />

      <iframe
        *ngIf="!vm.loading && vm.fileUrl && !vm.isImage"
        class="file-viewer-frame"
        [src]="vm.fileUrl">
      </iframe>
    </div>
  </div>
</ng-container>